module.exports = __webpack_public_path__ + "static/media/team-health-pool-caneca-personalizada01.5d2d1ecb.jpg";